// The 8 accepted wire intents. land:manage is NOT accepted (manage is commercial/residential only).
export const INTENTS = [
  "commercial:buy",
  "commercial:sell",
  "commercial:manage",
  "residential:buy",
  "residential:sell",
  "residential:manage",
  "land:buy",
  "land:sell",
] as const;

export type Intent = (typeof INTENTS)[number];
export type AssetType = "commercial" | "residential" | "land";
export type TxnType = "buy" | "sell" | "manage";

const INTENT_SET: ReadonlySet<string> = new Set(INTENTS);

export function isIntent(value: unknown): value is Intent {
  return typeof value === "string" && INTENT_SET.has(value);
}

// Decompose a wire intent into its asset/transaction parts. Throws on an unknown intent;
// callers validate with isIntent first (a 400 at the edge, never a decode of bad input).
export function decomposeIntent(intent: Intent): { assetType: AssetType; txnType: TxnType } {
  const [assetType, txnType] = intent.split(":") as [AssetType, TxnType];
  return { assetType, txnType };
}
